/**
 * 「AI 분석을 끄면 중점 분석 «영역»도 함께 버린다」 — 그 규칙 한 벌.
 *
 * 규칙 자체는 한 줄이지만 **쓰는 자리가 둘**이라 따로 둔다: 사진별 토글(`AiToggle`의 `onChange`)과
 * 「전체 적용」 바(`handleBulkApply`). 2026-10-05 리뷰에서 **후자가 빠진 채** 있었고, 그래서 이렇게
 * 났다 — 범위를 지정한 뒤 전체 적용 바에서 분석을 끄면 범위가 남는데 `aiOn=false`라 「범위 지정됨」
 * 배지가 **숨어서 보이지 않고**, 다시 켜서 전체 적용하면 그 사진만 **사용자가 지정한 기억이 없는**
 * 범위가 표시된 채 분석된다. 끄는 자리가 셋째로 늘면 여기를 부르게 할 것.
 *
 * ⚠️ 카테고리(`focusCategories`)는 이 함수에 넣지 않았다 — 두 자리의 **출처가 다르다**(사진별은
 * `photo.focusCategories`, 전체 적용은 `bulk.focusCategories`). 같은 모양으로 묶으면 그 차이가
 * 가려진다. 여기는 **영역 축만** 소유한다.
 */
import type { AnalysisRegion } from '@safetyhub/shared';

export function regionAfterAiToggle(
  aiEnabled: boolean,
  current: AnalysisRegion | null | undefined,
): AnalysisRegion | null {
  return aiEnabled ? current ?? null : null;
}
